import React, { useLayoutEffect, useState } from "react";
import { Tooltip, Modal, IconButton } from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import useSound from "use-sound";
import { Alignment, ObserverState } from "./sharedTypes";

interface PropTypes {
    activeObservers: ObserverState;
    alignment: Alignment;
}

function ObserverNotification({ activeObservers }: PropTypes) {
    const [isOpen, setIsOpen] = useState(false);

    const [playArrive] = useSound(
        '/sound/notification_6.mp3',
        { volume: .5 }
    );

    var anonObserverCount = activeObservers?.registrations.filter(obs => !obs.sharingName).length

    useLayoutEffect(() => {
        if (activeObservers?.newObserverPresent) {
            playArrive();
        }
    }, [activeObservers, playArrive]);

    //leaving this component in tact to preserve the "ding" sound when a new user joins, but removed the markup that would have followed here...
    return null;
}

export default ObserverNotification;
